// extracted by mini-css-extract-plugin
export var quantityInput = "_io-0";